<template>
  <div id="coupon-modal">
    <el-dialog :close-on-click-modal="false" v-model="showModal" custom-class="coupon-index-modal" v-show="!showCouponExplain">
      <div class="coupon-list-box">
        <div class="coupon-list" :class="{ 'coupon-list-scroll': coupons.length > 2 }">
          <coupon class="index-coupon-item" :show-more="false" v-for="(coupon, index) in coupons" :key="index" :coupon="coupon" :couponIndex="index" @couponExport="couponExport"></coupon>
        </div>
        <img class="coupon-box-img" src="../../assets/imgs/coupon/coupon-modal-middle.png" alt="" @mousedown="browserDragDefault()">
        <img class="coupon-box-img" src="../../assets/imgs/coupon/coupon-modal-top.png" alt="" @mousedown="browserDragDefault()">
      </div>
      <div class="coupon-tips" @mousedown="browserDragDefault()">
        <span>已存入</span>
        <a @click="gotoCoupon" class="my-coupon-link">我的优惠券</a>
      </div>
      <div class="close-btn" @click="close"><img src="../../assets/imgs/coupon/modal-close.png"></div>
    </el-dialog>

    <!-- 指定商品优惠券说明 -->
    <coupon-explain :coupon="coupons[couponIndex]" v-model="showCouponExplain" @couponExplainClose="couponExplainClose()"></coupon-explain>
  </div>
</template>

<script>
import coupon from './coupon';
import couponExplain from './coupon-explain';

export default {
  name: 'coupon-modal',
  components: {
    coupon,
    couponExplain,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },

    // 是否显示立即使用
    haveUseNow: {
      type: Boolean,
      default: true,
    },

    // 是否显示默认标题
    showDefaultTitle: {
      type: Boolean,
      default: true,
    },

    // 未读优惠券
    coupons: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      showModal: this.value, // 是否展示
      showCouponExplain: false, // 是否展示指定商品说明弹窗
      couponIndex: 0, // 优惠券索引值
    };
  },
  computed: {
    totalCouponCashPrice() {
      if (this.coupons && this.coupons.length > 0) {
        return this.coupons.map(coupon => coupon.cash_reduce).reduce((prevCouponCashReduce, currentCouponCashReduce) => prevCouponCashReduce + currentCouponCashReduce);
      }
      return 0;
    },
  },
  methods: {
    gotoCoupon() {
      this.$emit('input', false);
      this.$router.push({ name: 'coupon' });
    },
    // 关闭
    close() {
      this.$emit('input', false);
    },

    // 打开指定商品弹窗时
    couponInfo(value) {
      this.showCouponExplain = value.isShowCouponExplain;
      this.couponIndex = value.couponIndex;
    },

    // 指定商品弹窗关闭时
    couponExplainClose() {
      this.showCouponExplain = false;
    },

    couponExport(type, value) {
      if (type === 'couponExplain') {
        this.couponInfo(value);
      }
    },

    // 去除浏览器拖动默认行为
    browserDragDefault() {
      event.preventDefault();
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable";
#coupon-modal {
  .coupon-index-modal {
    width: 540px;
    border-radius: 14px;
    background-color: transparent;
    margin-bottom: 0;
    top: 50% !important;
    transform: translate(-50%, -50%);
    box-shadow: none;
    .el-dialog__header {
      height: 0;
      margin: 0;
      padding: 0;
      .el-dialog__headerbtn {
        display: none;
      }
    }
    .el-dialog__body {
      position: relative;
      padding: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 14px;
      .coupon-list-box {
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        width: 540px;
        height: 550px;
        position: relative;
        background: url('../../assets/imgs/coupon/coupon-modal-bottom.png') no-repeat center center;
        .coupon-list {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          width: 380px;
          max-height: 330px;
          padding-bottom: 80px;
          background: transparent;
          position: relative;
          top: 5px;
          z-index: 2;
          .index-coupon-item {
            margin-top: 15px;
            margin-bottom: 15px;
            &:first-child {
              margin-top: 0;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
          &::-webkit-scrollbar {
            width: 5px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 8px;
            box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
            background: #e8dacc;
          }
          &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
            border-radius: 8px;
            background: #fdeddb;
          }
        }
        .coupon-list-scroll {
          width: 385px;
        }
        img.coupon-box-img {
          position: absolute;
          &:first-of-type {
            top: 0;
            left: 0;
            z-index: 1;
          }
          &:last-of-type {
            bottom: 0;
            left: 30px;
            z-index: 3;
          }
        }
      }
      .coupon-tips {
        display: flex;
        justify-content: center;
        position: relative;
        bottom: 35px;
        z-index: 4;
        span {
          font-size: 14px;
          margin-right: 6px;
          color: #fce4b7;
          opacity: 0.7;
        }
        a {
          font-size: 14px;
          color: #fce4b7;
          text-decoration: underline;
        }
      }
      .close-btn {
        position: absolute;
        bottom: -76px;
        width: 36px;
        height: 36px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/coupon-modal.vue